import { render, staticRenderFns } from "./ProductTechnicalFilterRange.vue?vue&type=template&id=49761497"
import script from "./ProductTechnicalFilterRange.vue?vue&type=script&lang=js"
export * from "./ProductTechnicalFilterRange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductTechnicalFilterSlider: require('/app/components/ProductTechnicalFilterSlider.vue').default,ColorTemperatureSwatch: require('/app/components/ColorTemperatureSwatch.vue').default})
